var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ressource-not-found-container"
  }, [_c('v-card', {
    staticClass: "ressource-not-found-card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "text-center not-found-content"
  }, [_c('div', {
    staticClass: "not-found-illustration mb-4"
  }, [_c('MasterSvg', {
    attrs: {
      "use": "noresult"
    }
  })], 1), _c('h1', {
    staticClass: "font-weight-bold mb-3 not-found-title"
  }, [_vm._v(" " + _vm._s(_vm.$translate("notFoundTitle")) + " ")]), _c('p', {
    staticClass: "text-body-1 mb-4 grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("notFoundMessage")) + " ")]), _c('div', {
    staticClass: "not-found-actions"
  }, [_c('v-btn', {
    staticClass: "w-100 w-sm-auto",
    attrs: {
      "color": "grey",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.$translate('back')) + " ")], 1), _c('v-btn', {
    staticClass: "w-100 w-sm-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'dashboard'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-home")]), _vm._v(" " + _vm._s(_vm.$translate('goToHome')) + " ")], 1)], 1), _c('Info', {
    staticClass: "text-left mt-5 mb-5",
    attrs: {
      "collapsible": "",
      "title": _vm.$translate('possibleReasons')
    }
  }, [_c('ul', {
    staticClass: "text-body-2"
  }, [_c('li', [_vm._v(_vm._s(_vm.$translate("reason1")))]), _c('li', [_vm._v(_vm._s(_vm.$translate("reason2")))]), _c('li', [_vm._v(_vm._s(_vm.$translate("reason3")))]), _c('li', [_vm._v(_vm._s(_vm.$translate("reason4")))])])]), _vm.message ? _c('v-alert', {
    staticClass: "mt-6 mb-6",
    attrs: {
      "type": "warning",
      "outlined": "",
      "text": ""
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")])]) : _vm._e(), _c('p', {
    staticClass: "text-body-2 mb-2 grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("helpMessage")) + " ")]), _c('div', [_c('p', {
    staticClass: "text-body-2 mb-2 d-flex align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-email")]), _c('a', {
    staticClass: "support-link",
    attrs: {
      "href": "mailto:support@safetee.io"
    }
  }, [_vm._v("support@safetee.io")])], 1), _c('p', {
    staticClass: "text-body-2 mb-0 d-flex align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-phone")]), _c('a', {
    staticClass: "support-link",
    attrs: {
      "href": "tel:+33972195305"
    }
  }, [_vm._v("+33 9 72 19 53 05")])], 1)])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }